import { Box } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  listItem: People.TaskDto;
}

export const Task: React.FC<Props> = ({ listItem }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  const dueDateSoonSxStyles =
    moment(listItem.dueDate) > moment() &&
    moment(listItem.dueDate) < moment().add(1, 'week')
      ? sxStyles.dueDateSoon
      : {};

  const dueDatePastSxStyles =
    moment(listItem.dueDate) < moment() ? sxStyles.dueDatePast : {};

  const dueDateSxStyles = { ...dueDateSoonSxStyles, ...dueDatePastSxStyles };

  return (
    <SummaryItem
      href={`/page-ui2-redirect?empId=${listItem.assignee?.id}&area=collaboration`}
      avatarProps={{
        alt: listItem.assignee!.firstName,
        src: listItem.assignee!.profilePic,
      }}
      primaryElement={`${listItem.assignee!.firstName} ${
        listItem.assignee!.lastName
      }`}
      secondaryElement={
        <>
          {listItem.title}
          {listItem.dueDate && (
            <>
              {`, `}
              <Box component="span" sx={dueDateSxStyles} data-id="date">
                {`${t('dueOn')} ${moment(listItem.dueDate).format('L')}`}
              </Box>
            </>
          )}
        </>
      }
    />
  );
};
